import axios from 'axios'
import {ResponseCRUD, ResponseObject, ResponseObjectPaginated} from '../model'
import {ConfigDocumentColumnModel, ConfigDocumentModelDTO} from '../model/configDocument.model'

const BASEURL = process.env.REACT_APP_DEV_API_CENTRAL_URL
export function getDocsConfig(dto: ConfigDocumentModelDTO, page: number) {
  return axios.post<ResponseObjectPaginated<ConfigDocumentColumnModel[]>>(
    `${BASEURL}/docsconfig/getAll/${page}`,
    dto,
  )
}

export function getDocsConfigById(dto: any | undefined) {
  return axios.get<ResponseObject<ConfigDocumentColumnModel>>(
    `${BASEURL}/docsconfig/getInformationById?Id=${dto}`,
  )
}

export function createDocsConfig(dto: ConfigDocumentModelDTO) {
  return axios.post<ResponseCRUD>(`${BASEURL}/docsconfig/createDocsConfig`, dto)
}

export function deleteDocsConfig(dto: any) {
  return axios.delete<ResponseCRUD>(`${BASEURL}/docsconfig/deleteDocsConfig?id=${dto}`)
}

export function updateDocsConfig(dto: ConfigDocumentModelDTO) {
  return axios.put<ResponseCRUD>(`${BASEURL}/docsconfig/updateDocsConfig`, dto)
}
